import { render } from "./PriceCard.vue?vue&type=template&id=3c8a7cda&scoped=true"
import script from "./PriceCard.vue?vue&type=script&lang=js"
export * from "./PriceCard.vue?vue&type=script&lang=js"

import "./PriceCard.vue?vue&type=style&index=0&id=3c8a7cda&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3c8a7cda"]])

export default __exports__